export default __webpack_public_path__ + "static/media/bike.fcb9553a.svg";